import { createAction } from '@reduxjs/toolkit';

// entrypoint actions
export const GET_PRINT_TEMPLATES = 'GET_PRINT_TEMPLATES';
export const GET_PRINT_TEMPLATE = 'GET_PRINT_TEMPLATE';
export const CREATE_PRINT_TEMPLATE = 'CREATE_PRINT_TEMPLATE';
export const UPDATE_PRINT_TEMPLATE = 'UPDATE_PRINT_TEMPLATE';
export const DELETE_PRINT_TEMPLATES = 'DELETE_PRINT_TEMPLATES';

export const GET_PAGINATED_PRINT_TEMPLATES = 'GET_PAGINATED_PRINT_TEMPLATES';

export const GET_PRINT_TAGS = 'GET_PRINT_TAGS';
export const GETTING_PRINT_TAGS = 'GETTING_PRINT_TAGS';
export const GETTING_PRINT_TAGS_FAILED = 'GETTING_PRINT_TAGS_FAILED';
export const GETTING_PRINT_TAGS_SUCCEEDED = 'GETTING_PRINT_TAGS_SUCCEEDED';

export const SET_CURRENT_PRINT_TEMPLATE = 'SET_CURRENT_PRINT_TEMPLATE';
export const UNSET_CURRENT_PRINT_TEMPLATE = 'UNSET_CURRENT_PRINT_TEMPLATE';
export const CLEAR_PRINT_TEMPLATE_ERROR = 'CLEAR_PRINT_TEMPLATE_ERROR';

export const CLEAR_PRINT_TEMPLATE_STORE = 'CLEAR_PRINT_TEMPLATE_STORE';

export const WARN_AND_ARCHIVE_PRINT_TEMPLATE =
  'WARN_AND_ARCHIVE_PRINT_TEMPLATE';

// async actions
export const GETTING_PRINT_TEMPLATES = 'GETTING_PRINT_TEMPLATES';
export const GETTING_PRINT_TEMPLATES_SUCCEEDED =
  'GETTING_PRINT_TEMPLATES_SUCCEEDED';
export const GETTING_PRINT_TEMPLATES_FAILED = 'GETTING_PRINT_TEMPLATES_FAILED';

export const GETTING_PRINT_TEMPLATE = 'GETTING_PRINT_TEMPLATE';
export const GETTING_PRINT_TEMPLATE_FAILED = 'GETTING_PRINT_TEMPLATE_FAILED';
export const GETTING_PRINT_TEMPLATE_SUCCEEDED =
  'GETTING_PRINT_TEMPLATE_SUCCEEDED';

export const CREATING_PRINT_TEMPLATE = 'CREATING_PRINT_TEMPLATE';
export const CREATING_PRINT_TEMPLATE_SUCCEEDED =
  'CREATING_PRINT_TEMPLATE_SUCCEEDED';
export const CREATING_PRINT_TEMPLATE_FAILED = 'CREATING_PRINT_TEMPLATE_FAILED';

export const UPDATING_PRINT_TEMPLATE = 'UPDATING_PRINT_TEMPLATE';
export const UPDATING_PRINT_TEMPLATE_SUCCEEDED =
  'UPDATING_PRINT_TEMPLATE_SUCCEEDED';
export const UPDATING_PRINT_TEMPLATE_FAILED = 'UPDATING_PRINT_TEMPLATE_FAILED';

export const DELETING_PRINT_TEMPLATES = 'DELETING_PRINT_TEMPLATES';
export const DELETING_PRINT_TEMPLATES_SUCCEEDED =
  'DELETING_PRINT_TEMPLATES_SUCCEEDED';
export const DELETING_PRINT_TEMPLATES_FAILED =
  'DELETING_PRINT_TEMPLATES_FAILED';

export const PRINT_AUTO_SAVE_TIMER_START = 'PRINT_AUTO_SAVE_TIMER_START';
export const PRINT_AUTO_SAVE_TIMER_END = 'PRINT_AUTO_SAVE_TIMER_END';

export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE';
export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE_SUCCEEDED =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE_SUCCEEDED';
export const GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE_FAILED =
  'GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE_FAILED';

export const SET_COPY_CURRENT_PRINT_TEMPLATE =
  'SET_COPY_CURRENT_PRINT_TEMPLATE';

export const GETTING_PAGINATED_PRINT_TEMPLATES = 'GETTING_PAGINATED_PRINT_TEMPLATES';
export const GETTING_PAGINATED_PRINT_TEMPLATES_SUCCEEDED =
  'GETTING_PAGINATED_PRINT_TEMPLATES_SUCCEEDED';
export const GETTING_PAGINATED_PRINT_TEMPLATES_FAILED =
  'GETTING_PAGINATED_PRINT_TEMPLATES_FAILED';

export const GET_PRINT_FILE = 'GET_PRINT_FILE';
export const GETTING_PRINT_FILE_SUCCEEDED = 'GETTING_PRINT_FILE_SUCCEEDED';
export const GETTING_PRINT_FILE_FAILED = 'GETTING_PRINT_FILE_FAILED';
export const DOWNLOADED_PRINT_FILE = 'DOWNLOADED_PRINT_FILE';
export const SET_TEST_DOWNLOAD = 'SET_TEST_DOWNLOAD';

export const UPDATE_PRINT_FILTERS = 'UPDATE_PRINT_FILTERS';
export const RESET_PRINT_FILTERS = 'RESET_PRINT_FILTERS';

export const getPrintTemplates = createAction(GET_PRINT_TEMPLATES);

export const getPrintTemplate = createAction(GET_PRINT_TEMPLATE);

export const createPrintTemplate = createAction(CREATE_PRINT_TEMPLATE);

export const updatePrintTemplate = createAction(UPDATE_PRINT_TEMPLATE);

export const deletePrintTemplates = createAction(DELETE_PRINT_TEMPLATES);

export const warnAndArchivePrintTemplate = createAction(
  WARN_AND_ARCHIVE_PRINT_TEMPLATE
);

export const setCopyCurrentPrintTemplate = createAction(
  SET_COPY_CURRENT_PRINT_TEMPLATE
);

export const setCurrentPrintTemplate = createAction(SET_CURRENT_PRINT_TEMPLATE);

export const unsetCurrentPrintTemplate = createAction(
  UNSET_CURRENT_PRINT_TEMPLATE
);

export const clearTemplatePrintError = createAction(CLEAR_PRINT_TEMPLATE_ERROR);

export const clearPrintTemplateStore = createAction(CLEAR_PRINT_TEMPLATE_STORE);

export const gettingPrintTemplates = createAction(GETTING_PRINT_TEMPLATES);

export const gettingPrintTemplatesSucceeded = createAction(
  GETTING_PRINT_TEMPLATES_SUCCEEDED
);

export const gettingPrintTemplatesFailed = createAction(
  GETTING_PRINT_TEMPLATES_FAILED
);

export const gettingPrintTemplate = createAction(GETTING_PRINT_TEMPLATE);

export const gettingPrintTemplateSucceeded = createAction(
  GETTING_PRINT_TEMPLATE_SUCCEEDED
);

export const gettingPrintTemplateFailed = createAction(
  GETTING_PRINT_TEMPLATE_FAILED
);

export const creatingPrintTemplate = createAction(CREATING_PRINT_TEMPLATE);

export const creatingPrintTemplateSucceeded = createAction(
  CREATING_PRINT_TEMPLATE_SUCCEEDED
);

export const creatingPrintTemplateFailed = createAction(
  CREATING_PRINT_TEMPLATE_FAILED
);

export const updatingPrintTemplate = createAction(UPDATING_PRINT_TEMPLATE);

export const updatingPrintTemplateSucceeded = createAction(
  UPDATING_PRINT_TEMPLATE_SUCCEEDED
);

export const updatingPrintTemplateFailed = createAction(
  UPDATING_PRINT_TEMPLATE_FAILED
);

export const deletingPrintTemplates = createAction(DELETING_PRINT_TEMPLATES);

export const deletingPrintTemplatesSucceeded = createAction(
  DELETING_PRINT_TEMPLATES_SUCCEEDED
);

export const deletingPrintTemplatesFailed = createAction(
  DELETING_PRINT_TEMPLATES_FAILED
);

export const gettingAssociatedCampaignsForPrintTemplate = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE
);

export const gettingAssociatedCampaignsForPrintTemplateSucceeded = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE_SUCCEEDED
);

export const gettingAssociatedCampaignsForPrintTemplateFailed = createAction(
  GETTING_ASSOCIATED_CAMPAIGNS_FOR_PRINT_TEMPLATE_FAILED
);

export const printAutoSaveTimerStart = createAction(
  PRINT_AUTO_SAVE_TIMER_START
);

export const printAutoSaveTimerEnd = createAction(PRINT_AUTO_SAVE_TIMER_END);

export const getPaginatedPrintTemplates = createAction(GET_PAGINATED_PRINT_TEMPLATES);

export const gettingPaginatedPrintTemplates = createAction(
  GETTING_PAGINATED_PRINT_TEMPLATES
);
export const gettingPaginatedPrintTemplatesSucceeded = createAction(
  GETTING_PAGINATED_PRINT_TEMPLATES_SUCCEEDED
);
export const gettingPaginatedPrintTemplatesFailed = createAction(
  GETTING_PAGINATED_PRINT_TEMPLATES_FAILED
);

export const getPrintTags = createAction(GET_PRINT_TAGS);
export const gettingPrintTags = createAction(GETTING_PRINT_TAGS);
export const gettingPrintTagsSucceeded = createAction(GETTING_PRINT_TAGS_SUCCEEDED);
export const gettingPrintTagsFailed = createAction(GETTING_PRINT_TAGS_FAILED);

export const getPrintFile = createAction(GET_PRINT_FILE);
export const gettingPrintFileSucceeded = createAction(GETTING_PRINT_FILE_SUCCEEDED);
export const gettingPrintFileFailed = createAction(GETTING_PRINT_FILE_FAILED);
export const downloadedPrintFile = createAction(DOWNLOADED_PRINT_FILE);
export const setTestDownload = createAction(SET_TEST_DOWNLOAD);

export const updatePrintFilters = createAction(UPDATE_PRINT_FILTERS);
export const resetPrintFilters = createAction(RESET_PRINT_FILTERS);